var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatLinkedin = function SvgStatLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A3",
    stroke: "#A6A5A3",
    d: "M6.176 9.87h1.597c.018 0 .032.014.033.032v6.922a.032.032 0 0 1-.033.032H6.176a.032.032 0 0 1-.032-.032V9.902c0-.018.014-.032.032-.032Zm3.726 0H11.5c.018 0 .032.014.032.032v1.41l.834-.75a2.677 2.677 0 0 1 1.796-.692 2.698 2.698 0 0 1 2.694 2.694v4.26a.032.032 0 0 1-.032.032h-1.597a.032.032 0 0 1-.033-.032v-3.993a1.832 1.832 0 0 0-3.662 0v3.993a.032.032 0 0 1-.032.032H9.902a.032.032 0 0 1-.032-.032V9.902c0-.018.014-.032.032-.032ZM6.975 6.144a.832.832 0 1 1 0 1.663.832.832 0 0 1 0-1.663Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.167,
    height: 19.167,
    x: 1.917,
    y: 1.917,
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.34,
    rx: 4
  })));
};
export default SvgStatLinkedin;